import React from 'react';
import UIDLink from 'common/components/UIDLink';
import { rightPaneAttributeBackground, rightPaneAttributecolor } from 'common/constants/colors';
import { arrayOf, shape, string } from 'prop-types';
import { ATTRIBUTE_TYPE_PROPTYPE } from 'common/constants/commonPropTypes';
import { formatAsFullDateAbbrMonth } from 'common/utils/time';

const RightPaneAttributesContainer = ({ attrData }) => {
  if (!attrData) {
    return <div />;
  }
  return attrData.map(attr => (
    <div key={attr.description} style={{ marginTop: '30px' }}>
      <div style={{ fontWeight: 'bold', textTransform: 'uppercase' }}>
        {attr.description}
      </div>
      <div style={{ marginTop: '7px' }}>
        {attr.attribute_types.map(o => (
          <div key={o.description} style={{ marginTop: '5px', alignItems: 'center', display: 'flex' }}>
            <div
              style={{
                backgroundColor: rightPaneAttributeBackground(attr.description),
                borderRadius: '20px',
                color: rightPaneAttributecolor,
                padding: '0px 10px',
                textAlign: 'center',
              }}
            >
              {o.description}
            </div>
            <div style={{ color: '#999999', marginLeft: '10px' }}>
              {o.datatype === 'UID'
                ? o.attributes.map((v, i, arr) => {
                  if (arr.length - 1 === i) {
                    return <UIDLink uid={v.value} />;
                  }
                  return <UIDLink comma uid={v.value} />;
                })
                : o.attributes
                  .map(v => {
                    if (o.datatype === 'TIME') {
                      return formatAsFullDateAbbrMonth(v.value);
                    }
                    return v.value;
                  })
                  .join(', ')}
            </div>
          </div>
        ))}
      </div>
    </div>
  ));
};
RightPaneAttributesContainer.propTypes = { attrData: arrayOf(shape({
  description: string,
  attribute_types: arrayOf(ATTRIBUTE_TYPE_PROPTYPE),
})) };
RightPaneAttributesContainer.defaultProps = { attrData: [] };

export default RightPaneAttributesContainer;
